module.exports = __webpack_public_path__ + "static/media/3-chris-gayle.dd833a1a.png";